import { Radio } from '@mui/material';
import { RadioProps } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props extends RadioProps {
  design: FormPublicDesignFragment;
}

const Field = styled(Radio)<{ design: FormPublicDesignFragment }>`
  flex: 1;
  width: 100%;
  background: none;

  &.MuiRadio-root {
    color: ${({ design }) => design.colors.answer};
    justify-content: flex-start;
  }

  &.MuiRadio-root.Mui-checked {
    color: ${({ design }) => design.colors.button};
  }

  & + .MuiTypography-root {
    width: 100%;
  }
  &.MuiTouchRipple-root {
    width: 100%;
  }
`;

export const StyledRadio = (props: Props) => {
  return <Field {...props} />;
};
